module.exports = __webpack_public_path__ + "img/minesIcon.e41ed3e1.svg";